export class ApplicationLaunchRequest {
  modulePath: string;
  argumentsText: string;
}
